import { useRef } from "react";
import { AgGridReact } from "ag-grid-react";

import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";

import { Content_PRD2050_R01 } from "./Content_PRD2050_R01";
import { DetailTable_PRD2050_R01 } from "./DetailTable_PRD2050_R01";
import { PRD2050_R01Dto, PRD2050_R01LotDto } from "./Dto_PRD2050_R01";
import { Modal_PRD2050_R01 } from "./Modal_PRD2050_R01";
import { SearchSection_PRD2050_R01 } from "./SearchSection_PRD2050_R01";
import { usePRD2050_R01Store } from "./Store_PRD2050_R01";
import { Table_PRD2050_R01 } from "./Table_PRD2050_R01";

/**
 * PRD2050_R01 화면의 구성 요소와 액션바 이벤트를 연결한다.
 * 상단 작업지시, 하단 투입 LOT, LOT 선택 모달이 같은 Store 상태를 공유한다.
 */
export const Container_PRD2050_R01 = () => {
  const { isModalVisible } = usePRD2050_R01Store();
  const gridRef = useRef<AgGridReact<PRD2050_R01Dto> | null>(null);
  const detailGridRef = useRef<AgGridReact<PRD2050_R01LotDto> | null>(null);

  const {
    handleSearchClick,
    handleOrderRowClick,
    handleOrderRowDoubleClick,
    handleModalOpenClick,
    handleDeleteClick,
    handleSaveClick,
    initData,
  } = Content_PRD2050_R01();

  return (
    <div className="content-container">
      <Actionbar
        onFetchClick={handleSearchClick}
        onCreateClick={() => {}}
        onDeleteClick={handleDeleteClick}
        onSaveClick={handleSaveClick}
        onInitClick={initData}
      />
      <SearchSection_PRD2050_R01 />
      {isModalVisible && <Modal_PRD2050_R01 />}

      <div className="flex-1 flex flex-col p-[12px] gap-[12px]">
        <div className="h-1/2">
          <Table_PRD2050_R01
            gridRef={gridRef}
            onSelectOrder={handleOrderRowClick}
            onOpenMaterialLot={handleOrderRowDoubleClick}
          />
        </div>
        <div className="h-1/2">
          <DetailTable_PRD2050_R01 gridRef={detailGridRef} />
        </div>
      </div>
      <Message />
    </div>
  );
};
